module.exports = __WEBPACK_EXTERNAL_MODULE_i18next__;